var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { AccessibilityService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
const { decreaseFontSize, getFontSize, increaseFontSize, isContrastEnabled, scrollToTop, setContrastEnabled, setFontSize, } = AccessibilityService;
class AccessibilityAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
    }
    /**
     * Sets the font size.
     *
     * @param fontSize - The new font size (defaults to 100).
     */
    setFontSize(fontSize = 100) {
        const { minFontSize, maxFontSize } = this.state;
        if (fontSize < minFontSize || fontSize > maxFontSize) {
            return;
        }
        setFontSize(fontSize);
    }
    /**
     * Returns the current font size.
     */
    getFontSize() {
        return getFontSize();
    }
    /**
     * Sets if the contrast should be enabled.
     *
     * @param contrastEnabled - If the contrast should be enabled.
     */
    setContrastEnabled(contrastEnabled = false) {
        setContrastEnabled(contrastEnabled);
    }
    /**
     * Returns if the contrast is enabled.
     */
    isContrastEnabled() {
        return isContrastEnabled();
    }
    /**
     * Toggles between contrast enabled and disabled.
     */
    toggleContrast() {
        setContrastEnabled(!isContrastEnabled());
    }
    /**
     * Increases the font size by the configured step.
     */
    increaseFontSize() {
        const { fontSizeStep, maxFontSize } = this.state;
        increaseFontSize(fontSizeStep, maxFontSize);
    }
    /**
     * Decreases the font size by the configured step.
     */
    decreaseFontSize() {
        const { fontSizeStep, minFontSize } = this.state;
        decreaseFontSize(fontSizeStep, minFontSize);
    }
    /**
     * Resets to the default font size.
     */
    resetFontSize() {
        this.setFontSize();
    }
    /**
     * Sets the minimum font size.
     *
     * @param minFontSize - The minimum font size.
     */
    setMinFontSize(minFontSize) {
        this.setState({ minFontSize });
        this.setFontSize(Math.max(minFontSize, this.getFontSize()));
    }
    /**
     * Returns the current minimum font size.
     */
    getMinFontSize() {
        return this.state.minFontSize;
    }
    /**
     * Sets the maximum font size.
     *
     * @param maxFontSize - The maximum font size.
     */
    setMaxFontSize(maxFontSize) {
        this.setState({ maxFontSize });
        this.setFontSize(Math.min(maxFontSize, getFontSize()));
    }
    /**
     * Returns the current maximum font size.
     */
    getMaxFontSize() {
        return this.state.maxFontSize;
    }
    /**
     * Sets the font size step.
     *
     * @param fontSizeStep - The new font size step.
     */
    setFontSizeStep(fontSizeStep) {
        this.setState({ fontSizeStep });
    }
    /**
     * Returns the current font size step.
     */
    getFontSizeStep() {
        return this.state.fontSizeStep;
    }
    /**
     * Scrolls to the top of the page.
     */
    scrollToTop() {
        scrollToTop();
    }
    /**
     * Resets the font size to the default value and disables the contrast.
     */
    clear() {
        this.resetFontSize();
        this.setContrastEnabled(false);
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AccessibilityAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AccessibilityAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AccessibilityAPI.prototype, "onContextMenuClick", void 0);
export { AccessibilityAPI, };
//# sourceMappingURL=accessibility-api.js.map